import React, { PureComponent } from 'react';
import { formatDate } from '../../lib/utils/date';
import { Duration } from '../../lib/utils/duration';
import { IWithI18nProps, withI18n } from '../context/i18n';

interface IDateTimeProps extends IWithI18nProps {
  type: 'date' | 'duration';
  value: string | number;
  className?: string;
  dataHook?: string;
}

class DateTime extends PureComponent<IDateTimeProps> {
  formatValue(value: Date | Duration) {
    if (value instanceof Duration) {
      return this.props.t('duration.minutes', { minutes: value.getMinutes() });
    }
    return formatDate(value, this.props.locale);
  }

  render() {
    const { value: rawValue, className, dataHook, type } = this.props;
    const value = type === 'date' ? new Date(rawValue) : new Duration(rawValue);
    return (
      <time
        className={className}
        data-hook={dataHook}
        dateTime={value.toISOString()}
      >
        {this.formatValue(value)}
      </time>
    );
  }
}

const I18NDateTime = withI18n(DateTime);
export default I18NDateTime;
